var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_88)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.437 29.0604C43.2965 29.6898 38.8812 32.793 36.6545 37.3416C35.3493 40.0079 34.933 42.2895 35.0085 46.3643L35.0388 48H37.6975H40.3563L40.418 45.1507C40.4713 42.6785 40.5085 42.2037 40.6983 41.5628C41.7575 37.9867 44.5467 35.3406 48.0467 34.5912C49.0232 34.3822 50.9787 34.3822 51.9552 34.5912C55.4552 35.3406 58.2444 37.9867 59.3036 41.5628C59.4934 42.2037 59.5306 42.6785 59.584 45.1507L59.6456 48H62.3044H64.9631L64.9947 46.4171C65.0313 44.5804 64.8726 42.0964 64.6508 41.0351C63.383 34.97 58.5657 30.28 52.5047 29.2099C51.3656 29.0088 49.4377 28.9379 48.437 29.0604Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_88)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.995 43.0693C33.2515 43.3065 32.5888 43.8898 32.2009 44.6484C32.0086 45.0243 32 45.552 32 56.9922V68.9433L32.2363 69.4028C32.5117 69.9382 33.1161 70.5216 33.6641 70.7809C34.0135 70.9462 35.5594 70.966 50.1764 70.9932C61.5263 71.0144 66.4716 70.9869 66.8718 70.9006C67.5798 70.748 68.2416 70.2371 68.6741 69.5093L69 68.9609V57.001C69 45.5522 68.9914 45.0243 68.7991 44.6484C68.5188 44.1001 67.9984 43.5499 67.4898 43.2639L67.0583 43.0213L50.6618 43.0021C41.6437 42.9916 34.1436 43.0218 33.995 43.0693ZM49.2379 49.9005C46.4463 50.9369 45.6596 54.5392 47.7554 56.6887L48.2612 57.2075L48.2749 60.2778L48.2886 63.3482L48.6136 64.0093C49.0698 64.9374 49.6527 65.3524 50.5 65.3524C51.3473 65.3524 51.9302 64.9374 52.3864 64.0093L52.7114 63.3482L52.7251 60.2874L52.7388 57.2265L53.2557 56.6889C54.1629 55.7451 54.5924 54.3793 54.3755 53.1277C54.1346 51.7377 53.3312 50.6442 52.1181 50.0556C51.3211 49.6689 50.0466 49.6002 49.2379 49.9005Z",
    fill: "url(#paint1_linear_1062_88)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.995 43.0693C33.2515 43.3065 32.5888 43.8898 32.2009 44.6484C32.0086 45.0243 32 45.552 32 56.9922V68.9433L32.2363 69.4028C32.5117 69.9382 33.1161 70.5216 33.6641 70.7809C34.0135 70.9462 35.5594 70.966 50.1764 70.9932C61.5263 71.0144 66.4716 70.9869 66.8718 70.9006C67.5798 70.748 68.2416 70.2371 68.6741 69.5093L69 68.9609V57.001C69 45.5522 68.9914 45.0243 68.7991 44.6484C68.5188 44.1001 67.9984 43.5499 67.4898 43.2639L67.0583 43.0213L50.6618 43.0021C41.6437 42.9916 34.1436 43.0218 33.995 43.0693ZM49.2379 49.9005C46.4463 50.9369 45.6596 54.5392 47.7554 56.6887L48.2612 57.2075L48.2749 60.2778L48.2886 63.3482L48.6136 64.0093C49.0698 64.9374 49.6527 65.3524 50.5 65.3524C51.3473 65.3524 51.9302 64.9374 52.3864 64.0093L52.7114 63.3482L52.7251 60.2874L52.7388 57.2265L53.2557 56.6889C54.1629 55.7451 54.5924 54.3793 54.3755 53.1277C54.1346 51.7377 53.3312 50.6442 52.1181 50.0556C51.3211 49.6689 50.0466 49.6002 49.2379 49.9005Z",
    stroke: "url(#paint2_linear_1062_88)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_88",
    x: 29.85,
    y: 40.85,
    width: 41.3,
    height: 32.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_88"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_88",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_88",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_88",
    x1: 35.9594,
    y1: 45.5833,
    x2: 70.4542,
    y2: 69.1853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_88",
    x1: 53.5833,
    y1: 47.6667,
    x2: 62.0936,
    y2: 73.9066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9d321feba47fe09884201cde48d956f5.svg";
export { ForwardRef as ReactComponent };